import { render, staticRenderFns } from "./MainAppHorizontalBarGraph.vue?vue&type=template&id=b3841104&scoped=true&"
import script from "./MainAppHorizontalBarGraph.vue?vue&type=script&lang=ts&"
export * from "./MainAppHorizontalBarGraph.vue?vue&type=script&lang=ts&"
import style0 from "./MainAppHorizontalBarGraph.vue?vue&type=style&index=0&id=b3841104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3841104",
  null
  
)

export default component.exports